import { get, post, put } from "./apiClient";

export default {
  async list(requestModel) {
    if (!requestModel?.customerId) {
      throw new Error("Customer ID is required");
    }

    if (!requestModel?.products) {
      throw new Error("Products are required");
    }

    if (!requestModel?.privilege) {
      throw new Error("Privilege is required");
    }

    return await post("user/facilities", requestModel);
  },

  async get({ facilityId } = {}) {
    if (!facilityId) {
      throw new Error("Facility ID is required");
    }

    return await get(`facility/${encodeURIComponent(facilityId)}`);
  },

  async createFacility(facility) {
    return await post("facility/create", facility);
  },

  async getObservationSettings(facilityId) {
    return await get(
      `facility/${encodeURIComponent(facilityId)}/observationSettings`
    );
  },

  async getSettings(id) {
    return await get(`facility/${encodeURIComponent(id)}/settings`);
  },

  async setArchiveStatus(id, status) {
    await put(`facility/${encodeURIComponent(id)}/archivestatus`, status);
  },

  async updateBasicInfoSettings(facilityId, settingsUpdates) {
    return await put(
      `facility/${encodeURIComponent(facilityId)}/settings/basicInfo`,
      settingsUpdates
    );
  },

  async updateObservationSettings(facilityId, settingsUpdates) {
    return await put(
      `facility/${encodeURIComponent(facilityId)}/settings/observation`,
      settingsUpdates
    );
  },

  async cloneObservationNotes(facilityId, request) {
    return await post(
      `facility/${encodeURIComponent(
        facilityId
      )}/settings/cloneObservationNotes`,
      request
    );
  },

  async updateReportSettings(facilityId, settingsUpdates) {
    await put(
      `facility/${encodeURIComponent(facilityId)}/settings/report`,
      settingsUpdates
    );
  },

  async updateServiceAlertSettings(facilityId, settingsUpdates) {
    return await put(
      `facility/${encodeURIComponent(facilityId)}/settings/serviceAlerts`,
      settingsUpdates
    );
  }
};
